import {useContext, useEffect} from 'react'
import {HarnessContext, SELECT_HARNESS} from '../context/context'
import InputText from '../../../common/InputText'
import Button from '../../../common/Button'
import {useParams} from 'react-router-dom'
import {postRequest, putRequest} from '../../../../services/base'
import {NavContext} from '../../../../context/global_context'
import {Col, Flex, Form, Modal, Row} from 'antd'
import {useIntl} from 'react-intl'

const HarnessFormModal = (props) => {
  const intl = useIntl()
  let { vehicle } = useParams()

  const [state, dispatch] = useContext(HarnessContext)
  const [, navDispatch] = useContext(NavContext)

  const [form] = Form.useForm()

  const closeFormPopup = () => {
    dispatch({
      type: SELECT_HARNESS,
      data: { selected_harness: {}, show_harness_popup: false },
    })
    form.resetFields()
  }

  const saveHarness = async (values) => {
    const formData = new FormData()
    Object.entries(values).forEach(([key, value]) => {
      if (value !== undefined && value !== null) {
        formData.append(key, value)
      }
    })
    formData.append('vehicle', vehicle)

    // Ensure harness_id is sent as read-only identifier
    const selected = state?.selected_harness || {}
    if (selected.harness_id) {
      formData.set('harness_id', selected.harness_id)
    }

    let res = null
    if (selected?.id) {
      res = await putRequest(
        `/api/harnesses/${selected.id}/?vehicle=${vehicle}`,
        formData
      )
    } else {
      res = await postRequest(`/api/harnesses/?vehicle=${vehicle}`, formData)
    }

    if (res?.status !== false) {
      navDispatch({
        type: 'notification',
        data: {
          notification_type: 'success',
          msg: intl.formatMessage({ id: 'harnesses.updateSuccess' }),
        },
      })
      props.getHarnessListData()
      closeFormPopup()
    } else {
      navDispatch({
        type: 'notification',
        data: {
          notification_type: 'error',
          msg: intl.formatMessage({ id: 'harnesses.saveError' }),
        },
      })
    }
  }

  // Initialize form when modal opens
  useEffect(() => {
    if (!state.show_harness_popup) return
    const mod = state?.selected_harness || {}
    form.setFieldsValue({
      harness_id: mod.harness_id || null,
      part_number: mod.part_number || null,
      base_part_number: mod.base_part_number || null,
      abbreviation: mod.abbreviation || null,
      description: mod.description || null,
    })
  }, [state.show_harness_popup])

  return (
    <Modal
      open={state.show_harness_popup}
      title={intl.formatMessage({ id: 'harnesses.harnessDetails' })}
      width="50%"
      className="harnesses-form-modal"
      centered={true}
      footer={null}
      closable={true}
      onCancel={closeFormPopup}
    >
      <div className="container">
        <Form
          id="harness-form"
          name="harness-form"
          form={form}
          layout="vertical"
          onFinish={saveHarness}
        >
          <Row gutter={[16, 16]}>
            <Col span={12}>
              <InputText
                name="harness_id"
                label={intl.formatMessage({ id: 'harnesses.harnessId' })}
                isRequired={true}
                disabled
              />
            </Col>

            <Col span={12}>
              <InputText
                name="part_number"
                label={intl.formatMessage({ id: 'harnesses.partNumber' })}
                isRequired={true}
              />
            </Col>

            <Col span={12}>
              <InputText
                name="base_part_number"
                label={intl.formatMessage({ id: 'harnesses.harnessType' })}
                isRequired={false}
              />
            </Col>

            <Col span={12}>
              <InputText
                name="abbreviation"
                label={intl.formatMessage({ id: 'harnesses.abbreviation' })}
                isRequired={false}
              />
            </Col>

            <Col span={24}>
              <InputText
                name="description"
                label={intl.formatMessage({ id: 'harnesses.description' })}
                isRequired={false}
              />
            </Col>

            <Col span={24}>
              <Flex justify="end">
                <Button htmlType="submit" type="primary">
                  {intl.formatMessage({ id: 'harnesses.save' })}
                </Button>
              </Flex>
            </Col>
          </Row>
        </Form>
      </div>
    </Modal>
  )
}

export default HarnessFormModal
